import { render, staticRenderFns } from "./before-page-header.vue?vue&type=template&id=b5cb21de&scoped=true&"
import script from "./before-page-header.vue?vue&type=script&lang=js&"
export * from "./before-page-header.vue?vue&type=script&lang=js&"
import style0 from "./before-page-header.vue?vue&type=style&index=0&id=b5cb21de&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5cb21de",
  null
  
)

export default component.exports